import clsx from "clsx";
import { toast } from "react-toastify";

import { NotifCard } from "@organisms/notify/notifCard";
import { INotifCardVariantsEnum } from "@organisms/notify/types";

import type {
  INotifyPromiseProps,
  INotifyProps,
} from "@organisms/notify/types";

const info = (props: INotifyProps) => {
  toast.info(
    <NotifCard
      {...props}
      className={clsx(props.className, "w-100")}
      variant={INotifCardVariantsEnum.Information}
    />,
    {
      className: clsx("toast"),
    },
  );
};

const error = ({ toastId, ...props }: INotifyProps) => {
  toast.error(
    <NotifCard
      {...props}
      className={clsx(props.className, "w-100")}
      variant={INotifCardVariantsEnum.Error}
    />,
    {
      className: clsx("toast"),
      toastId,
    },
  );
};

const success = (props: INotifyProps) => {
  toast.success(
    <NotifCard
      {...props}
      className={clsx(props.className, "w-100")}
      variant={INotifCardVariantsEnum.Success}
    />,
    {
      className: clsx("toast"),
    },
  );
};

const warning = (props: INotifyProps) => {
  toast.warning(
    <NotifCard
      {...props}
      className={clsx(props.className, "w-100")}
      variant={INotifCardVariantsEnum.Warning}
    />,
    {
      className: clsx("toast"),
    },
  );
};

const feature = (props: INotifyProps) => {
  toast.warning(
    <NotifCard
      {...props}
      className={clsx(props.className, "w-100")}
      variant={INotifCardVariantsEnum.Feature}
    />,
    {
      className: clsx("toast"),
    },
  );
};

const promise = async <TData = unknown, TError = unknown>(
  props: INotifyPromiseProps<TData, TError>,
) => {
  return toast.promise<TData, TError>(props.promise, {
    pending: {
      className: clsx("toast"),
      render: (
        <NotifCard
          {...props.pending}
          className={clsx(props.pending.className, "w-100")}
          variant={INotifCardVariantsEnum.Promise}
        />
      ),
    },
    success: {
      className: clsx("toast"),
      render: (data) => {
        return (
          <NotifCard
            {...props.success}
            className={clsx(props.success, "w-100")}
            variant={INotifCardVariantsEnum.Success}
            title={
              typeof props.success.title === "function"
                ? props.success.title(data.data)
                : props.success.title
            }
            description={
              typeof props.success.description === "function"
                ? props.success.description(data.data)
                : props.success.description
            }
          />
        );
      },
    },
    error: {
      className: clsx("toast"),
      render: (data) => {
        return (
          <NotifCard
            {...props.error}
            className={clsx(props.error.className, "w-100")}
            variant={INotifCardVariantsEnum.Error}
            title={
              typeof props.error.title === "function"
                ? props.error.title(data.data)
                : props.error.title
            }
            description={
              typeof props.error.description === "function"
                ? props.error.description(data.data)
                : props.error.description
            }
          />
        );
      },
    },
  });
};

export const notify = {
  info,
  error,
  success,
  warning,
  feature,
  promise,
};
